// Gumbalimba child theme scripts
// Compiled by Vite -> dist/main.js (npm run build)
// Enqueued by functions.php with filemtime() cachebusting.
// (SCSS is compiled separately via sass CLI, not imported here.)


document.addEventListener('DOMContentLoaded', function () {
    const contactBar = document.getElementById('brxe-mfhtjy');
    const logoNav = document.getElementById('brxe-dkmbzu');
    if (!contactBar || !logoNav) return;

    // Disable scroll anchoring: when the sticky header resizes (logo shrink/
    // unshrink), Chrome would otherwise bump scrollY to keep the viewport
    // stable, and those bumps get misread as "scroll down" events below,
    // hiding the contact bar while the user is actually scrolling up.
    document.documentElement.style.overflowAnchor = 'none';

    const logoContainer = document.getElementById('brxe-mpovla');
    const logoImg = logoContainer ? logoContainer.querySelector('img') : null;
    const navRight = document.getElementById('brxe-uvawdx');
    const contactHeight = contactBar.offsetHeight;

    let contactHidden = false;
    let logoShrunk = false;
    let logoTransitioning = false;
    let lastScrollY = window.scrollY;
    let scrollDirection = 'down';

    contactBar.style.transition = 'transform 0.3s ease';
    contactBar.style.willChange = 'transform';

    logoNav.style.transition = 'transform 0.3s ease, padding 0.3s ease, height 0.3s ease';
    logoNav.style.willChange = 'transform';

    if (logoImg) {
        logoImg.style.transition = 'width 0.3s ease';
        logoImg.style.height = 'auto';
    }

    if (navRight) {
        navRight.style.transition = 'none';
        navRight.querySelectorAll('*').forEach(function (el) {
            el.style.transition = 'none';
        });
    }

    window.addEventListener('scroll', function () {
        const y = window.scrollY;
        const delta = y - lastScrollY;
        lastScrollY = y;

        // Require a minimum delta before flipping direction. Tiny (<3px)
        // changes are usually layout artifacts, not intentional scrolls.
        if (Math.abs(delta) >= 3) {
            scrollDirection = delta > 0 ? 'down' : 'up';
        }

        // Contact bar: only hide on scroll DOWN, only show on scroll UP.
        // Skip entirely while the logo is mid-resize to avoid any residual
        // layout-shift scroll artifacts flipping the bar state.
        if (!logoTransitioning) {
            if (scrollDirection === 'down' && !contactHidden && y > 80) {
                contactHidden = true;
                contactBar.style.transform = 'translateY(-100%)';
                contactBar.style.pointerEvents = 'none';
                logoNav.style.transform = 'translateY(-' + contactHeight + 'px)';
            } else if (scrollDirection === 'up' && contactHidden) {
                contactHidden = false;
                contactBar.style.transform = 'translateY(0)';
                contactBar.style.pointerEvents = '';
                logoNav.style.transform = 'translateY(0)';
            }
        }

        // Logo shrink (independent of contact bar)
        if (!logoShrunk && y > 500) {
            logoShrunk = true;
            logoTransitioning = true;
            setTimeout(function () { logoTransitioning = false; }, 350);
            if (logoImg) logoImg.style.width = '300px';
            logoNav.style.height = '136px';
            logoNav.style.paddingTop = '12px';
            logoNav.style.paddingBottom = '12px';
        } else if (logoShrunk && y < 400) {
            logoShrunk = false;
            logoTransitioning = true;
            setTimeout(function () { logoTransitioning = false; }, 350);
            if (logoImg) logoImg.style.width = '';
            logoNav.style.height = '';
            logoNav.style.paddingTop = '1em';
            logoNav.style.paddingBottom = '50px';
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const openIcon = document.querySelector('.open-icon');
    const closeIcon = document.querySelector('.close-icon');
    // The mega-menu icons only exist on the full site header. Pages with a
    // stripped header (e.g. WooCommerce checkout) omit them, so bail out to
    // avoid "Cannot read properties of null (reading 'addEventListener')".
    if (!openIcon || !closeIcon) return;

    // Fade the mega menu dark overlay in lockstep with the slide animation.
    // Bricks plays the 500ms slideOutUp on the content BEFORE adding .hide to
    // the popup, so keying the fade off .hide leaves the overlay visible for
    // the full slide. Drive the backdrop opacity from the click handler via
    // inline style instead — CSS (transition: opacity .3s on .brx-popup-backdrop)
    // handles the actual fade, and inline opacity beats every CSS rule in the
    // cascade, so Bricks' internal state changes can't stomp it.
    function findBackdrops() {
        return document.querySelectorAll('.brx-popup:not(.brx-infobox-popup):not(.brx-infobox-popup-builder) .brx-popup-backdrop');
    }

    openIcon.addEventListener('click', function () {
        openIcon.style.display = 'none';
        closeIcon.style.display = 'inline-block';
        // Clear any inline opacity set by the close handler so Bricks' .hide →
        // unhidden state change can drive the CSS fade-in from 0 → 1.
        findBackdrops().forEach(function (bd) { bd.style.opacity = ''; });
    });

    closeIcon.addEventListener('click', function () {
        closeIcon.style.display = 'none';
        openIcon.style.display = 'inline-block';
        // Start the overlay fade immediately, at the same instant Bricks starts
        // the slideOutUp on the content. The CSS transition handles the 300ms
        // fade; this just flips the target.
        findBackdrops().forEach(function (bd) { bd.style.opacity = '0'; });
    });
});

/* Mini cart ikon → /cart/ oldal redirect. Törölhető ha vissza kell csinálni.
document.addEventListener('click', function(e) {
var cartLink = e.target.closest('.mini-cart-link, .cart-icon, .brxe-woocommerce-mini-cart a');
if (cartLink) {
e.preventDefault();
e.stopPropagation();
window.location.href = '/cart/';
}
}, true);*/

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 500) {
            // Hozzáadjuk az osztályt a body-hoz
            document.body.classList.add('scrolled-past-500');
        } else {
            // Levesszük az osztályt a body-ról
            document.body.classList.remove('scrolled-past-500');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {

    // --- 1. A KATTINTÁS (Event Delegation módszerrel) ---
    document.addEventListener('click', function (e) {
        var kattintottKosar = e.target.closest('.sajat-kosar-ikon');

        if (kattintottKosar) {
            e.preventDefault();
            var footerKosarGomb = document.querySelector('.brxe-woocommerce-mini-cart .toggle-button');
            if (footerKosarGomb) {
                footerKosarGomb.click();
            }
        }
    });

    // --- 2. SZÁMLÁLÓ SZINKRONIZÁLÁSA MINDEN IKONON ---
    function szinkronizal() {
        // FIGYELEM: Itt a querySelectorAll-t használjuk, hogy megtalálja az asztalit ÉS a mobilosat is!
        var szamlalok = document.querySelectorAll('.sajat-kosar-szamlalo');
        var footerSzamlalo = document.querySelector('.brxe-woocommerce-mini-cart .cart-count');

        if (szamlalok.length > 0 && footerSzamlalo) {
            var tisztaSzam = footerSzamlalo.textContent.trim();

            // Végigmegyünk az összes megtalált piros bogyón, és mindet frissítjük
            szamlalok.forEach(function (szamlalo) {
                szamlalo.innerHTML = tisztaSzam;

                if (tisztaSzam === '0' || tisztaSzam === '') {
                    szamlalo.style.opacity = '0';
                    szamlalo.style.pointerEvents = 'none';
                } else {
                    szamlalo.style.opacity = '1';
                }
            });
        }
    }

    // A) Lefuttatjuk egyszer az elején
    setTimeout(szinkronizal, 300);

    // B) Lefuttatjuk WooCommerce AJAX frissítéskor
    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('added_to_cart removed_from_cart updated_wc_div wc_fragments_refreshed', function () {
            setTimeout(szinkronizal, 500);
        });
    }
});
